import React, { PropsWithChildren } from 'react';
import Icon, { icons } from '@components/Icon';
import { cn } from '@lib/tw';

type Props = PropsWithChildren<{
  className?: string;
  icon: (typeof icons)[number];
  iconColor?: string;
  iconSize: string;
  uppercase?: boolean;
}>;

export const TextWithIcon = (props: Props) => (
  <div className={cn('flex items-center gap-2', props.className)}>
    {props.icon ? (
      <Icon
        name={props.icon}
        color={props.iconColor || '#242424'}
        fontSize={props.iconSize}
        className="align-middle"
      />
    ) : null}
    <span className={props.uppercase ? 'uppercase' : ''}>{props.children}</span>
  </div>
);
